import { render, staticRenderFns } from "./GeneralLedger.vue?vue&type=template&id=1c3b0796&scoped=true&"
import script from "./GeneralLedger.vue?vue&type=script&lang=js&"
export * from "./GeneralLedger.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLedger.vue?vue&type=style&index=0&id=1c3b0796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b0796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3b0796')) {
      api.createRecord('1c3b0796', component.options)
    } else {
      api.reload('1c3b0796', component.options)
    }
    module.hot.accept("./GeneralLedger.vue?vue&type=template&id=1c3b0796&scoped=true&", function () {
      api.rerender('1c3b0796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/accountingreport/GeneralLedger.vue"
export default component.exports